import module from 'contabilidad/polizas/module.js'
import * as moment from 'moment'

const schema = {
  Fecha_Movimiento: 'date',
  transacciones: {
    Total: 'number',
  },
}

const cadA = 'P  AAAAMMDD    +      JJJJ 1 0          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n'
const cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n'
const formaPago = '1'

const padEnd = (string, length) => string.substring(0, length).padEnd(length)

export class ProvisionIngresosPagos {
  constructor ($http, $filter, $schema) {
    this.$http = $http
    this.$schema = $schema
  }

  get (fecha_inicio, fecha_fin, ID_Cliente, CuentaBancaria, ids_clientes, campo) {
    return this.$http.get('/kendu/contabilidad/polizas/polizaProvisionIngresosPagos', {
      params: {
        fecha_inicio: moment(fecha_inicio).format('YYYY-MM-DD'),
        fecha_fin: moment(fecha_fin).format('YYYY-MM-DD'),
        ID_Cliente: ID_Cliente,
        CuentaBancaria: CuentaBancaria,
        ids_clientes: ids_clientes,
        campo: campo,
      },
      schema,
    })
  }

  condificarProvisionIngresosPagos (data, inicioPoliza) {
    try {
      return data.reduce((cadenaPrincipal, item, indice) => {
        if (indice === 0) {
          cadenaPrincipal += cadA
            .replace('AAAAMMDD', moment(item.Fecha_Movimiento).format('YYYYMMDD'))
            .replace('+', formaPago)
            .replace('JJJJ', String(inicioPoliza).padStart(4, '0'))
            .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', padEnd('INGRESOS DEL DIA', 60))
        }

        item.transacciones.forEach((value, index) => {
          const concepto = index === 0 ? moment(item.Fecha_Movimiento).format('DD/MM/YYYY') : `F-${item.Facturas}`
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', padEnd(value.Cuenta_Contable.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', padEnd(concepto, 15))
            .replace('*', value.Naturaleza === 'C' ? '0' : '1')
            .replace('YYYYYYYYY', padEnd(value.Total.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', padEnd(item.Nombre_Cliente, 43))
        })

        inicioPoliza++

        return cadenaPrincipal
      }, '')
    } catch (err) {
      return 'Error'
    }
  }
}

module.service('provisionIngresosPagos', ProvisionIngresosPagos)



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/provisionIngresosPagos.js